import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from './AuthContext';

export default function AdminRoute() {
    const { checkRole, userDetails } = useContext(AuthContext);

    if (!userDetails) return null;
    return checkRole(['Admin']) ? <Outlet /> : <Navigate to="/home" replace />;
}
